import { render, staticRenderFns } from "./simplified.vue?vue&type=template&id=d5163138&scoped=true&"
import script from "./simplified.vue?vue&type=script&lang=js&"
export * from "./simplified.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/output2.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5163138",
  null
  
)

export default component.exports